import './blog.css'
import Navbar from '../../components/navbar/Navbar'
import Singleblog from '../../components/singleblog/SingleBlog';
import Footer from '../../components/footer/Footer'
import blogDetails from '../../components/singleblog/data';

const Blog = () => {
    const data = blogDetails
    return (
        <div className='blog'>
            <Navbar/>
            <div className='blog--container'>
            <div className='img-wrapper'>
            <img className='blog--img' src={require('../../assets/logo.png')} alt=''/>
            <p>Explore place you'd wishing to spend your life time</p>
            </div>
            <div className='blog-wrapper'>
            {
                data.map((d) => (
                   <Singleblog data={d}/>
                )) 
            }
                
            </div>
            <div className='blog-guide'>
                <div className='blog-desc'>
                    <h1>Positive view.</h1>
                    <p>Don’t go in guns blazing when you approach a neighbor about what’s bugging you. Drop by and approach the subject in a friendly fashion, or, should you need to gently escalate the situation, request that they meet you for coffee. That will indicate that the issue is a big deal to you.Neighbors often don’t realize that they’re creating a problem, and it’s best to avoid seeming like you’re accusing them. Put yourself in their shoes, and start by assuming that their problematic behavior is not because of any ill will towards you.</p>
                </div>
                 <div className='blog-desc'>
                    <h1>Be sympathetic if your neighbor complains.</h1>
                    <p>While it’s important to bring up problems to your neighbor in a constructive way, it’s just as crucial to be thoughtful and cooperative when you’re the one accused of poor behavior. The complaint may not make much sense to you — for example, leaves from a tree on your property falling into your neighbor’s yard. But it’s more important to be friendly and accommodating than to be “right.” Respond to any complaints or requests the way you’d like them to respond to yours. If you’re willing to try to make their lives better, they’ll be more likely to do the same for you.</p>
                </div>
                 <div className='blog-desc'>
                    <h1>Document everything, just in case.</h1>
                    <p>With luck, you won’t ever need to involve a third-party when sorting out how to deal with bad neighbors, but it’s always possible. While it’s worth doing everything you can to resolve an issue peacefully and willingly, you should also document every step along the way just in case. On the off chance that you need to involve a homeowner association (HOA), a neighborhood group, the city building department, or even the local police or an attorney, maintain a record of relevant dates, times, emails, texts, and even photos, so the facts are at your fingertips if you need them.</p>
                </div>
                <button>More</button>
            </div>
            </div>
            <Footer/>
        </div>
    );
}

export default Blog;
